export default function getResource(label, vars = []) {
    const resources = {
        shade: `Shade ${vars[0]}`,
        showFewerShades: 'Show fewer shades',
        showMoreShades: `Show ${vars[0]} more shades`,
        previousSwatches: 'Previous swatches',
        nextSwatches: 'Next swatches'
    };

    return resources[label];
}
